import type { ReactNode } from 'react'
import { Sidebar } from '@/components/Sidebar'
import { FlashMessages } from '@/components/FlashMessages'

interface AuthenticatedLayoutProps {
  children: ReactNode
}

export default function AuthenticatedLayout({ children }: AuthenticatedLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />

      <div className="pt-14 md:pt-0 md:pl-[240px]">
        <main className="min-h-screen">
          <FlashMessages />
          {children}
        </main>
      </div>
    </div>
  )
}
